import { FormGroup } from 'react-bootstrap';
import type { VoidFunctionComponent } from 'react';

import { isFreeTier } from '../../../../../shared/subscriptions/utils';
import { window } from '../../../../globals';
import LabeledTextInput from '../../../generic/Forms/LabeledTextInput';
import PaidFeatureGate from '../../../generic/Gates/PaidFeatureGate';
import Text from '../../../generic/Text';
import type { GeneralSettings } from '../../../../../shared/settings/general';

import PackageLabelSelector from './PackageLabelsSelector/PackageLabelSelector';

type Props = {
  settings: GeneralSettings;
  onUpdateSettings: (settings: Partial<GeneralSettings>) => void;
  isDisabled: boolean;
};

/**
 * Displays the components section of the general settings page.
 */
const ComponentsSection: VoidFunctionComponent<Props> = ({ settings, isDisabled, onUpdateSettings }) => {
  return (
    <>
      <hr />
      <Text.H3>Packages</Text.H3>
      <PaidFeatureGate
        isRestricted={isFreeTier({
          plan: window.user?.organization?.stripe_plan,
          stripePriceLimit: window.user?.organization?.stripePriceLimit,
        })}
      >
        <PackageLabelSelector
          settings={settings}
          onUpdateSettings={onUpdateSettings}
          isDisabled={isDisabled}
        />
      </PaidFeatureGate>
      <div>
        <FormGroup>
          <LabeledTextInput
            labelVariant="legacy"
            label="Internal Package Signatures"
            value={settings.dependencySignatures || ''}
            placeholder="Separate multiple signatures with commas"
            onChange={(dependencySignatures) => {
              onUpdateSettings({
                dependencySignatures,
              });
            }}
            isDisabled={isDisabled}
          />
        </FormGroup>
        {settings.dependencySignatures ? (
          <p>
            <span>FOSSA will ignore dependencies that match:</span>
            {settings.dependencySignatures.split(',').map((dependencySignature) => (
              <code className="margin-right-sm">{dependencySignature.trim()}</code>
            ))}
          </p>
        ) : (
          <p>
            Use this field to specify signatures for marking internal package naming conventions. FOSSA will recognize
            any package that contains these signatures in their names as internal dependencies and will ignore these
            dependencies.
          </p>
        )}
      </div>
    </>
  );
};

export default ComponentsSection;
